<template>
    <div class="module-wa-autosender">
        <SOSlotBase :container-name="'detail-perangkat'">
            <template v-slot:title-bar>
                <div>
                    <SOTitleBar :page-title="pagetitle" :type="`${isTestMsg ? 'back' : 'close'}`" @back="back" />
                </div>
            </template>

            <template v-slot:content>
                <div class="p-x-20 p-t-16">
                    <div class="connected-device d-flex justify-content-center align-items-center" v-if="!isTestMsg">
                        <div style="text-align: center;">
                            <IconBased :width="90" :height="90">
                                <template v-slot:icons>
                                    <CheckedCircleBlueBig />
                                </template>
                            </IconBased>

                            <label class="m-d-0 p-t-16" style="display: block;">Perangkat terhubung!</label>
                        </div>
                    </div>
                    <div class="connected-content">
                        <div
                            class="info"
                            :class="{ gagal: isTestSucces !== null && isTestSucces === false, sukses: isTestSucces }"
                        >
                            <label class="m-d-0" v-if="isTestSucces === null && !isTestMsg">
                                Sebelum melanjutkan, silakan mencoba kirim pesan untuk memastikan WA Autosender bekerja
                                dengan normal.
                            </label>
                            <label class="m-d-0" v-if="isTestSucces === null && isTestMsg">
                                Silakan mencoba kirim pesan untuk memastikan WA Autosender bekerja dengan normal.
                            </label>
                            <label class="m-d-0" v-if="isTestSucces !== null">
                                <IconBased :width="16" :height="16">
                                    <template v-slot:icons>
                                        <WarningTriangle icon-fill="#DA1E28" v-if="isTestSucces === false" />
                                        <CheckCircleGreen v-else />
                                    </template>
                                </IconBased>
                                <span style="padding-left: 8px;" v-if="isTestSucces === false">
                                    Pesan gagal dikirim
                                </span>
                                <span style="padding-left: 8px;" v-if="isTestSucces === true">Pesan terkirim</span>
                            </label>
                        </div>
                        <div v-if="isFetching">
                            <div
                                class="d-flex justify-content-center align-items-center"
                                v-if="isFetching"
                                style="height:237px;"
                            >
                                <span class="spinner-border f-c-midgrey" role="status" aria-hidden="true"></span>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="isTestSucces === null">
                                <div class="m-d-16">
                                    <SOInputTelp
                                        id="nomor-tujuan-test"
                                        title="Nomor tujuan"
                                        :required="true"
                                        :country-code="country_code"
                                        placeholder="8123456789"
                                        autocomplete="off"
                                        :value="nomor"
                                        @input="onInput($event, 'nomor')"
                                        @country-code="setCountryCode"
                                    />
                                    <ErrorMessage
                                        ref="invalidNumber"
                                        class="error"
                                        label="Nomor tujuan"
                                        :validation="$v.nomor"
                                    />
                                    <div class="v-error" v-if="nomorInvalid">Nomor tidak valid</div>
                                </div>
                                <div class="m-d-16">
                                    <SOInputRegular
                                        id="isi-pesan"
                                        title="Isi pesan"
                                        :required="true"
                                        placeholder="Isi pesan..."
                                        autocomplete="off"
                                        :value="message"
                                        @input="onInput($event, 'message')"
                                    />
                                    <ErrorMessage class="error" label="Isi pesan" :validation="$v.message" />
                                </div>
                                <div style="text-align: right;">
                                    <SOButton :outline="true" :text="'Kirim pesan'" :id="`send-msg`" @action="send" />
                                </div>
                            </div>
                            <div v-else>
                                <div class="m-d-16">
                                    <label class="m-d-0">{{ resMsg }}</label>
                                </div>
                                <div style="text-align: center;">
                                    <SOButton
                                        v-if="isTestSucces === true"
                                        :primary="true"
                                        :text="'Lanjut ke integrasi outlet'"
                                        :id="`rescan-device`"
                                        @action="toOutlet"
                                    />
                                    <SOButton
                                            v-if="isTestSucces === true"
                                            :outline="true"
                                            :text="'Selesai. Kembali Ke Detail Perangkat'"
                                            :id="`back-device`"
                                            @action="toListPerangkat"
                                    />

                                    <SOButton
                                        v-if="isTestSucces === false"
                                        :outline="true"
                                        :text="'Scan ulang QR Code'"
                                        :id="`rescan-device`"
                                        @action="toConnectDevice"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import resulter from "@/store/utils/resulter";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOInputTelp from "@/so-components/global/input/SOInputTelp.vue";
import SOInputRegular from "@/so-components/global/input/SOInputRegular.vue";
import SOButton from "@/so-components/global/ui/SOButton";
import ErrorMessage from "@/component-items/ErrorMessage";

import IconBased from "../components/iconPack/IconBased.vue";
import CheckedCircleBlueBig from "../components/iconPack/CheckedCircleBlueBig.vue";
import WarningTriangle from "../components/iconPack/WarningTriangle.vue";
import CheckCircleGreen from "../components/iconPack/CheckCircleGreen.vue";

import { minLength, required } from "vuelidate/lib/validators";

import { moduleName } from "../store/state";

export default {
    name: "DeviceConnect",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOInputTelp,
        SOInputRegular,
        ErrorMessage,
        SOButton,
        IconBased,
        CheckedCircleBlueBig,
        WarningTriangle,
        CheckCircleGreen,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.setDefaultData();
            vm.setFromRoute(from.name);
        });
    },
    data() {
        return {
            fromRoute: null,
            nomor: "",
            message: "",
            country_code: "62",
            isTestSucces: null,
            resMsg: "",
            nomorInvalid: false,
        };
    },
    validations: {
        nomor: {
            required,
            minLength: minLength(8),
        },
        message: {
            required,
        },
    },
    mounted() {
        this.setFetching(false);
    },
    watch: {
        nomor: function(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.nomorInvalid = false;
            }
        },
        dataDevice: function(nD, oD) {
            if (nD.iddevice !== oD.iddevice) {
                if (nD.outlet > 0) {
                    this.back();
                }
            }
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            dataDeviceTiny: "dataDeviceTiny",
            dataDevice: "dataDevice",
            jwtToken: "jwtToken",
        }),
        getToken() {
            return this.jwtToken();
        },
        isTestMsg() {
            return this.fromRoute === "wa_autosender.detail_perangkat";
        },
        pagetitle() {
            return this.isTestMsg ? "Test Pesan" : "";
        },
        getNumber() {
            return this.getToken.Telp;
        },
        getDate() {
            return this.$moment().format("Do MMM YYYY HH:mm");
        },
        getDefaultMessage() {
            return `Test Pesan WA AUTOSENDER +${this.dataDeviceTiny.country_code}${this.dataDeviceTiny.number} - ${this.dataDeviceTiny.nama} . ${this.getDate}`;
        },
    },
    methods: {
        ...mapActions({
            getDetailDevice: `${moduleName}/getDetailDevice`,
            sendTestMessage: `${moduleName}/sendTestMessage`,
            setFetching: `${moduleName}/setFetching`,
            setResponse: `${moduleName}/setResponse`,
            getDetailTinyDevice: `${moduleName}/getDetailTinyDevice`,
        }),
        back() {
            this.$router.push({ name: "wa_autosender.detail_perangkat" });
        },
        setFromRoute(val) {
            this.fromRoute = val;
        },
        init() {
            if (this.$route.params.id_device) {
                this.getDetailTinyDevice({ id_mesin: this.$route.params.id_device });
            }
        },
        onInput(val, target) {
            this[target] = val;
        },
        setCountryCode(val) {
            this.country_code = val;
        },
        setDefaultData() {
            setTimeout(() => {
                this.nomor = this.getNumber;
                this.message = this.getDefaultMessage;
            }, 100);
        },
        isValid() {
            let { nomor, message } = this.$v;
            nomor.$touch();
            message.$touch();

            return nomor.$invalid || message.$invalid;
        },
        send() {
            if (this.isValid()) {
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
                return;
            }

            let posted = {
                device_id: this.$route.params.id_device,
                to: `${this.country_code}${this.nomor}`,
                message: this.message,
            };

            this.sendTestMessage(posted)
                .then((response) => {
                    if (!response.data) {
                        this.$toast.error(response);
                    } else {
                        let { code, status, msg, data } = response.data;
                        if (status && code === 200) {
                            if (this.fromRoute === "wa_autosender.detail_perangkat") {
                                this.back();
                            }

                            if (!this.dataDevice.iddevice) {
                                this.getDetailDevice({ id_mesin: this.getIdDevice });
                            } else {
                                if (this.dataDevice.outlet > 0) {
                                    this.back();
                                }
                            }
                            this.isTestSucces = true;
                            this.resMsg =
                                "WA Autosender berhasil mengirim pesan dan bekerja dengan normal. Anda bisa melanjutkan integrasi outlet.";
                            this.$toast.success(msg);
                        } else {
                            if (data === "[NUM_INVALID]") {
                                this.nomorInvalid = true;
                                this.isTestSucces = null;
                            } else {
                                this.isTestSucces = false;
                            }
                            this.resMsg = msg;
                            this.$toast.error(msg);
                        }
                    }
                    this.setFetching(false);
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                    this.setResponse(resulter.errorResult(e));
                });
        },
        toConnectDevice() {
            this.$router.push({ name: "wa_autosender.connect_perangkat" });
        },
        toOutlet() {
            this.$router.push({ name: "wa_autosender.detail_perangkat.daftar_oulet.integrasi" });
        },
        toListPerangkat() {
            this.$router.push({ name: "wa_autosender.detail_perangkat" ,
                params:{"id_device":this.$route.params.id_device}
            });
        },
    },
};
</script>
<style scoped>
.v-error {
    color: red;
    font-size: 14px;
    margin-top: 4px;
}
.connected-device {
    min-height: 148px;
    height: 148px;
    margin-bottom: 30px;
}
.connected-content {
    border: 1px solid #c8d0dd;
    box-sizing: border-box;
    border-radius: 8px;
    padding: 12px 16px;
}
.connected-content .info {
    background-color: #f2f5f7;
    border: 1px solid #c8d0dd;
    border-bottom: unset;
    margin: -13px -17px 16px;
    padding: 12px 16px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}
.connected-content .gagal {
    background-color: #fff1f1;
}
.connected-content .sukses {
    background-color: #e8fcee;
}
</style>
